import React, { useEffect, useState } from "react";
import {
  startOfToday,
  endOfToday,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
} from "date-fns";

import { Link, withRouter, useParams, useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Row,
  TabContent,
  Table,
  TabPane,
  UncontrolledCollapse,
  UncontrolledDropdown,
} from "reactstrap";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";

//Images
import profileBg from "../../../assets/images/profile-bg.jpg";
import avatar1 from "../../../assets/images/users/avatar-1.jpg";
import light from "../../../assets/images/logo-light.png";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

const LivraisonsAnnulees = (props) => {
  const history = useHistory();
  //Début code pour get la course sélectionnée
  const livraisonsSelected = useParams("id");

  SwiperCore.use([Autoplay]);

  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }

  function statutColor(statut) {
    let color;
    switch (statut) {
      case "En attente":
        color = "warning";
        break;
      case "Accepter":
        color = "info";
        break;
      case "Pret":
        color = "primary";
        break;
      case "Commencer":
        color = "success";
        break;
      case "Terminer":
        color = "success";
        break;
      case "Annuler":
        color = "danger";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }
  function convertDate(date) {
    return new Date(date);
  }

  const [activityTab, setActivityTab] = useState("3");

  const toggleActivityTab = (tab) => {
    if (activityTab !== tab) {
      setActivityTab(tab);
    }
  };

  const [livraisonsList, setLivraisonsList] = useState([]);
  const fetchLivraisonList = async () => {
    try {
      const livraison_list = await axiosInstance.get(`/livraisondetail/`);

      setLivraisonsList(
        livraison_list.data.data
          .filter((livraison) => livraison.statut === "Annuler")
          .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
      );
      // console.log(livraison_list);
      // console.log("Livraison List: ", livraison_list.data.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    try {
      fetchLivraisonList();
    } catch (error) {
      console.error("Erreur de fetch livraison: ", error);
    }
    // finally {
    //   setTimeout(() => {
    //     setLoading(false);
    //   }, 2000);
    // }
  }, []);

  const [loading, setLoading] = useState(true);
  const [livraisonsPeriod, setLivraisonsPeriod] = useState("");
  const [livraisonsPeriodList, setLivraisonsPeriodList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [livraisonSelected, setLivraisonSelected] = useState({});

  const onChangeLivraisonsPeriod = (period = "") => {
    // console.log("livraisonsList: ", livraisonsList);

    let datedebut, datefin;
    let listFiltered = [];

    switch (period) {
      case "aujourd'hui":
        setLivraisonsPeriod("aujourd'hui");
        datedebut = startOfToday();
        datefin = endOfToday();
        break;
      case "semaine":
        setLivraisonsPeriod("semaine");
        datedebut = startOfWeek(new Date(), { weekStartsOn: 1 }); // Assuming the week starts on Monday
        datefin = endOfWeek(new Date(), { weekStartsOn: 1 });
        break;
      case "mois":
        setLivraisonsPeriod("mois");
        datedebut = startOfMonth(new Date());
        datefin = endOfMonth(new Date());
        break;
      case "an":
        setLivraisonsPeriod("an");
        datedebut = startOfYear(new Date());
        datefin = endOfYear(new Date());
        break;
      default:
        setLivraisonsPeriod("");
        datedebut = null;
        datefin = null;
        break;
    }

    if (datedebut && datefin) {
      // Conversion des dates en objets Date
      const dateDebut = convertDate(datedebut);
      const dateFin = convertDate(datefin);

      listFiltered = livraisonsList
        .filter(
          (livraison) =>
            convertDate(livraison.created_at) >= dateDebut &&
            convertDate(livraison.created_at) <= dateFin
        )
        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    } else {
      listFiltered = livraisonsList;
    }

    setLivraisonsPeriodList(listFiltered);

    return listFiltered;
    // console.log("datedebut: ", datedebut);
    // console.log("datefin: ", datefin);
    // console.log("list Filtered: ", listFiltered);
  };

  useEffect(() => {
    // console.log("livraisons Period List length: ", livraisonsPeriodList.length);
    onChangeLivraisonsPeriod();
  }, [livraisonsList]);

  // Recherche
  useEffect(() => {
    let list = onChangeLivraisonsPeriod(livraisonsPeriod);
    // console.log("list: ", list);

    const listFiltered =
      list &&
      list
        .filter(
          (livraison) =>
            (livraison.statut &&
              livraison.statut
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (livraison.adresse_depart &&
              livraison.adresse_depart
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (livraison.adresse_destination &&
              livraison.adresse_destination
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (livraison.nom &&
              livraison.nom.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (livraison.last_name_client &&
              livraison.last_name_client
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (livraison.first_name_client &&
              livraison.first_name_client
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (livraison.first_name_client &&
              livraison.first_name_client
                .toLowerCase()
                .includes(searchTerm.toLowerCase())) ||
            (livraison.first_name_conducteur &&
              livraison.first_name_conducteur
                .toLowerCase()
                .includes(searchTerm.toLowerCase()))
        )
        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    setLivraisonsPeriodList(listFiltered);
  }, [searchTerm, livraisonsList]);

  const [freeLivreur, setFreeLivreur] = useState([]);
  const getFreeLivreur = async () => {
    try {
      const freeLivreur = await axiosInstance.get(`/drivernocourse/`);
      const listFreeLivreur = freeLivreur.data.data.filter(
        (livreur) =>
          livreur.type_conducteur === "Livreur" &&
          livreur.type_engin === livraisonSelected.engin
      );
      // "Livreur";

      setFreeLivreur(listFreeLivreur);
      // console.log(freeLivreur);
      return freeLivreur;
    } catch (err) {
      console.error(err);
    }
  };

  const [modal, setModal] = useState(false);
  const [searchfreeDriver, setSearchFreeDriver] = useState(false);
  useEffect(() => {
    if (modal) {
      setSearchFreeDriver(true);
      getFreeLivreur();
      setSearchFreeDriver(false);
    }
  }, [modal]);

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      livreur: "",
    },
    validationSchema: Yup.object({
      livreur: Yup.string().required(
        props.t("Veuillez renseigner le chauffeur")
      ),
    }),
    onSubmit: async (values) => {
      // console.log("livreur: ", values.livreur);

      const assign_livreur = {
        user_id: values.livreur,
        course_id: livraisonSelected.id,
      };

      // console.log("assign_livreur: ", assign_livreur);

      try {
        const data = axiosInstance
          .put(`/attribuconducteurcourse/?id=${values.livreur}`, assign_livreur)
          .then((response) => {
            // dispatch(onUpdateChauffeur(updateChauffeur));
            validation.resetForm();
            toast.success(
              props.t("Le livreur a été assigné à cette livraison avec succès"),
              {
                autoClose: 3000,
              }
            );
          })
          .catch((error) => {
            toast.error(
              props.t("Echec d'assignation du livreur à la livraison"),
              {
                autoClose: 3000,
              }
            );
          });
        history.push(`/livraisons#${livraisonSelected.id}`);

        // window.location.reload(true);
      } catch (err) {
        console.error(err);
        toast.error(
          props.t("Echec d'assignation du Chauffeur à la livraison"),
          {
            autoClose: 2000,
          }
        );
      }

      setLivraisonSelected({});
      await fetchLivraisonList();
      await getFreeLivreur();
      setModal(false);
    },
  });

  document.title = "Livraisons annulées | Takci";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={props.t("Livraisons annulées")}
            pageTitle="Livraisons"
            pageTitleLink="/livraison"
          />

          <div className="profile-foreground position-relative mx-n4 mt-n4">
            <div className="profile-wid-bg">
              <img src={profileBg} alt="" className="profile-wid-img" />
            </div>
          </div>

          <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
            <Row className="g-4" style={{ justifyContent: "center" }}>
              <div className="col-auto">
                <div
                  className="avatar-lg"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={light} alt="user-img" width="100px" />
                </div>
              </div>
            </Row>
          </div>

          <div>
            <Row>
              <Col xxl={12}>
                <Row>
                  <Col lg={12}>
                    <Card>
                      <CardHeader className="align-items-center">
                        <div className="d-flex">
                          <h4 className="card-title mb-0  me-2">
                            Livraisons {livraisonsPeriod}
                          </h4>
                          <div className="flex-shrink-0 ms-auto">
                            <div className="justify-content-end d-none d-md-flex gap-1">
                              <button
                                disabled={livraisonsPeriod === ""}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeLivraisonsPeriod("tous");
                                }}
                              >
                                {props.t("Tous")}
                              </button>

                              <button
                                disabled={livraisonsPeriod === "aujourd'hui"}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeLivraisonsPeriod("aujourd'hui");
                                }}
                              >
                                {props.t("Today")}
                              </button>

                              <button
                                disabled={livraisonsPeriod === "semaine"}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeLivraisonsPeriod("semaine");
                                }}
                              >
                                {props.t("Week")}
                              </button>

                              <button
                                disabled={livraisonsPeriod === "mois"}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeLivraisonsPeriod("mois");
                                }}
                              >
                                {props.t("Month")}
                              </button>

                              <button
                                disabled={livraisonsPeriod === "an"}
                                className="btn"
                                style={{
                                  background: "#002437",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onChangeLivraisonsPeriod("an");
                                }}
                              >
                                {props.t("Year")}
                              </button>
                            </div>

                            <FormGroup className="d-block d-md-none">
                              <Input
                                id="exampleSelect"
                                name="select"
                                type="select"
                                onChange={(e) =>
                                  onChangeLivraisonsPeriod(e.target.value)
                                }
                              >
                                <option
                                  selected
                                  disabled={livraisonsPeriod === ""}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="tous"
                                >
                                  {props.t("Tous")}
                                </option>

                                <option
                                  disabled={livraisonsPeriod === "aujourd'hui"}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="aujourd'hui"
                                >
                                  {props.t("Today")}
                                </option>

                                <option
                                  disabled={livraisonsPeriod === "semaine"}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="semaine"
                                >
                                  {props.t("Week")}
                                </option>

                                <option
                                  disabled={livraisonsPeriod === "mois"}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="mois"
                                >
                                  {props.t("Month")}
                                </option>

                                <option
                                  disabled={livraisonsPeriod === "an"}
                                  className="btn"
                                  style={{
                                    background: "#002437",
                                    color: "white",
                                  }}
                                  value="an"
                                >
                                  {props.t("Year")}
                                </option>
                              </Input>
                            </FormGroup>
                          </div>
                        </div>
                        <div className="flex-shrink-0 ms-auto mt-3">
                          <div className="justify-content-end gap-1">
                            <Input
                              readOnly={livraisonsPeriodList.length <= 0}
                              type="text"
                              placeholder="Rechercher..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </div>
                        </div>
                      </CardHeader>
                      <CardBody>
                        <div>
                          <div className="profile-timeline">
                            <div></div>
                            <div
                              className="accordion accordion-flush"
                              // id="headingOne"
                            >
                              {!loading ? (
                                livraisonsPeriodList &&
                                livraisonsPeriodList.length > 0 ? (
                                  livraisonsPeriodList.map((livraison, key) => {
                                    return (
                                      <div
                                        className="accordion-item border-0"
                                        key={key}
                                      >
                                        <div
                                          className="accordion-header"
                                          id={`heading${key}`}
                                        >
                                          <Link
                                            to="#"
                                            className="accordion-button p-2 shadow-none"
                                            id="collapseTwo"
                                          >
                                            <div className="d-flex">
                                              <div
                                                className="flex-shrink-0"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <i
                                                  className={`bx bx-${
                                                    livraison.type_engin_id ===
                                                    1
                                                      ? "car"
                                                      : livraison.type_engin_id ===
                                                        1
                                                      ? ""
                                                      : "cycling"
                                                  } avatar-xs rounded-circle`}
                                                  style={{
                                                    border: "1px solid #002437",
                                                    background: "white",
                                                    fontSize: "2rem",
                                                  }}
                                                />
                                              </div>
                                              <div className="flex-grow-1 ms-3">
                                                <Row className="w-100 fs-14 mb-1 d-flex justify-content-between">
                                                  <Col xxl={9}>
                                                    {formatDate(
                                                      livraison.created_at
                                                    )}
                                                  </Col>

                                                  <Col
                                                    xxl={3}
                                                    className={`justify-content-end`}
                                                  >
                                                    <span
                                                      className={`badge bg-soft-${statutColor(
                                                        livraison.statut
                                                      )} text-${statutColor(
                                                        livraison.statut
                                                      )} align-middle`}
                                                    >
                                                      {livraison.statut}
                                                    </span>
                                                  </Col>
                                                </Row>
                                                <small className="text-muted">
                                                  {livraison.adresse_enlevement}
                                                  {" -- "}
                                                  {livraison.adresse_livraison}
                                                </small>
                                              </div>
                                            </div>
                                          </Link>
                                        </div>
                                        <UncontrolledCollapse
                                          className="accordion-collapse"
                                          toggler={`#heading${key}`}
                                          defaultOpen={
                                            livraisonsSelected
                                              ? livraisonsSelected.id ==
                                                livraison.id
                                              : key === 0
                                          }
                                        >
                                          <div className="accordion-body ms-2 ps-5">
                                            <ul className="list-unstyled text-muted vstack gap-3">
                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="bx bx-trip fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Départ: </b>
                                                    {
                                                      livraison.adresse_enlevement
                                                    }
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Code livraison: </b>
                                                    {livraison.code_livraison ? (
                                                      livraison.code_livraison
                                                    ) : (
                                                      <span
                                                        className={` text-danger`}
                                                      >
                                                        Pas de code
                                                      </span>
                                                    )}
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="bx bx-trip fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Destination: </b>
                                                    {
                                                      livraison.adresse_livraison
                                                    }
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Code Enlevement: </b>
                                                    {livraison.code_enlevement ? (
                                                      livraison.code_enlevement
                                                    ) : (
                                                      <span
                                                        className={` text-danger`}
                                                      >
                                                        Pas de code
                                                      </span>
                                                    )}
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Type d'engin: </b>
                                                    {
                                                      livraison.designation_type_engin
                                                    }
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Distance: </b>
                                                    {livraison.distance_estimee ||
                                                      0}
                                                    {" Km"}
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Type de colis: </b>
                                                    {livraison.type_colis}
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Coût estimé: </b>
                                                    {livraison.cout_estimee}
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Mode de paiement: </b>
                                                    {livraison.mode_payement}
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Client: </b>
                                                    <Link
                                                      to={`client/${livraison.client_id}`}
                                                    >
                                                      {
                                                        livraison.first_name_client
                                                      }{" "}
                                                      {
                                                        livraison.last_name_client
                                                      }
                                                    </Link>
                                                  </div>
                                                </div>
                                              </li>

                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Conducteur: </b>
                                                    {livraison.conducteur_id ? (
                                                      livraison.conducteur_id
                                                    ) : (
                                                      <button
                                                        disabled={modal}
                                                        className="btn btn-sm"
                                                        style={{
                                                          backgroundColor:
                                                            "#002437",
                                                          color: "#fff",
                                                        }}
                                                        onClick={async (e) => {
                                                          setModal(true);
                                                          setLivraisonSelected({
                                                            id: livraison.id,
                                                            engin:
                                                              livraison.designation_type_engin,
                                                          });
                                                        }}
                                                      >
                                                        Assigner un Livreur
                                                      </button>
                                                    )}
                                                  </div>
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </UncontrolledCollapse>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="text-center my-3">
                                    <h2>Pas de Livraisons</h2>
                                  </div>
                                )
                              ) : (
                                <div className="text-center my-3">
                                  <Loader style={{ color: "#014c94" }} />
                                  <h2>Chargement...</h2>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        <ToastContainer closeButton={false} />
        </Container>

        <Modal id="showModal" style={{ maxWidth: 800 }} isOpen={modal} centered>
          <ModalHeader className="bg-soft-info p-3">
            Assigner un chauffeur à une livraison
          </ModalHeader>
          <Form
            onSubmit={async (e) => {
              e.preventDefault();
              validation.handleSubmit();
              // setModal(false);
              // await fetchLivraisonList();
              // await getFreeLivreur();
            }}
          >
            <ModalBody>
              <Row className="g-3">
                <Col lg={12}>
                  <div>
                    <Label htmlFor="livreur" className="form-label">
                      {props.t("Livreurs libres")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Label>

                    {!searchfreeDriver ? (
                      <>
                        <Input
                          type="select"
                          name="livreur"
                          id="livreur"
                          className="form-control"
                          placeholder={props.t("Entrez le nom")}
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          defaultValue={validation.values.livreur || ""}
                          invalid={
                            validation.touched.livreur &&
                            validation.errors.livreur
                              ? true
                              : false
                          }
                        >
                          <option selected disabled value="">
                            {props.t("Free Driver")}
                            {"*"}
                          </option>

                          {freeLivreur.map((livreur, key) => {
                            return (
                              <>
                                <option value={`${livreur.user_id}`}>
                                  {livreur.first_name} {livreur.last_name} ::{" "}
                                  {livreur.type_engin}
                                </option>
                              </>
                            );
                          })}
                        </Input>
                        {validation.touched.livreur &&
                        validation.errors.livreur ? (
                          <FormFeedback type="invalid">
                            {validation.errors.livreur}
                          </FormFeedback>
                        ) : null}
                      </>
                    ) : (
                      <div className="text-center my-3 d-flex">
                        <Loader style={{ color: "#014c94" }} />
                        Chargement des Livreurs libres...
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </ModalBody>

            <ModalFooter>
              <div className="hstack gap-2 justify-content-end">
                <Button
                  type="button"
                  onClick={async () => {
                    setModal(false);
                    await fetchLivraisonList();
                    await getFreeLivreur();
                  }}
                  className="btn-light"
                >
                  {props.t("Fermer")}
                </Button>

                <Button
                  type="submit"
                  className="btn"
                  style={{ background: "#002437", color: "white" }}
                  id="assign-btn"
                >
                  Assigner le Chauffeur
                </Button>
              </div>
            </ModalFooter>
          </Form>
        </Modal>

        <ToastContainer closeButton={false} />
      </div>
    </React.Fragment>
  );
};

LivraisonsAnnulees.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(LivraisonsAnnulees));
